import * as React           from 'react'
import { FormattedMessage } from 'react-intl'

import Button      from '@material-ui/core/Button/Button'
import Card        from '@material-ui/core/Card/Card'
import CardActions from '@material-ui/core/CardActions/CardActions'
import CardHeader  from '@material-ui/core/CardHeader/CardHeader'

import { CoachingExperience } from '../../api'

interface CoachingExperienceCardProps {
  onRemove: () => void
  coachingExperience: CoachingExperience
}

const CoachingExperienceCard: React.SFC<CoachingExperienceCardProps> = ({
  onRemove,
  coachingExperience:
    {
      company,
      sector,
    },
}) => {
  const phrasing = {
    sector: <FormattedMessage id={`sectors.${sector}`} />
  }

  return (
    <Card>
      <CardHeader
        title={company}
        subheader={phrasing.sector}
      />
      <CardActions>
        <Button
          onClick={onRemove}
          variant={'raised'}
          color={'secondary'}
        >
          <FormattedMessage id={'buttonActions.remove'} />
        </Button>
      </CardActions>
    </Card>
  )
}

export default CoachingExperienceCard



// WEBPACK FOOTER //
// ./src/components/molecules/CoachingExperienceCard.tsx